
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/market-mix-modelling/create",
      function () {
        return require("private-next-pages/market-mix-modelling/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/market-mix-modelling/create"])
      });
    }
  